import Border, { IBorderValueProps } from '../../../puck/reusable-props/Border';
import { MarginType } from '../../../puck/reusable-props/margin';
import { PaddingType } from '../../../puck/reusable-props/padding';
import BackgroungColorComponent, {
  IBackgroundProps,
} from '../../customComponents/BackgroungColorComponent';
import WithAccordion from '../../customComponents/CustomAccordion';
import PaddingComponent from '../../customComponents/PaddingComponent';
import MarginComponent from '../../customComponents/MarginComponent';
import InputField from '../../../../components/common/input-field';
import { getNumberPatternWithAuto } from '../../../utils/helper';
import Toggle from '../../../../components/common/toggleButton';

export interface CommonProps {
  background: IBackgroundProps;
  border: IBorderValueProps;
  margin: MarginType;
  padding: PaddingType;
  height: string;
  position: string;
}

interface IProps {
  value: CommonProps;
  onChange: (_value: CommonProps) => void;
}

const option = [
  { label: 'Sticky', value: 'sticky-container', position: 'sticky-container' },
  { label: 'None', value: 'none', position: 'none' },
];

const Common = ({ value, onChange }: IProps) => {
  return (
    <WithAccordion title="Common">
      <PaddingComponent
        value={value.padding}
        onChange={padding => onChange({ ...value, padding })}
        title="Padding"
      />
      <MarginComponent
        value={value.margin}
        onChange={margin => onChange({ ...value, margin })}
        title="Margin"
      />
      <Border
        value={value.border}
        onChange={border => {
          onChange({ ...value, border });
        }}
        title="Border"
        showWidthProps={true}
      />
      <BackgroungColorComponent
        value={value.background}
        onChange={background => onChange({ ...value, background })}
      />
      <InputField
        value={value?.height}
        label="Height"
        onChange={e => {
          const newValue = getNumberPatternWithAuto(e);
          if (newValue !== null) {
            onChange({ ...value, height: newValue });
          }
        }}
      />
      <Toggle<CommonProps>
        value={value}
        onChange={newValue => {
          onChange({ ...value, ...newValue });
        }}
        heading={{ label: 'Position', value: 'position' }}
        options={option}
        propName="position"
      />
    </WithAccordion>
  );
};

export default Common;
